module.exports = __webpack_public_path__ + "img/copy.a7c0d3d3.svg";